// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ behavior = "auto", targetSelector }) {
  const location = useLocation();

  // 브라우저 기본 스크롤 복원 비활성화 (뒤로가기 등)
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      const prev = window.history.scrollRestoration;
      window.history.scrollRestoration = "manual";
      return () => { window.history.scrollRestoration = prev; };
    }
  }, []);

  // 경로 변경 때마다 맨 위로
  useEffect(() => {
    const el = targetSelector ? document.querySelector(targetSelector) : window;
    requestAnimationFrame(() => {
      if (!el) return;
      if (el === window) {
        window.scrollTo({ top: 0, left: 0, behavior }); // behavior: "auto" | "smooth"
      } else if ("scrollTo" in el) {
        el.scrollTo({ top: 0, left: 0, behavior });
      }
      // 보조: 일부 iOS 브라우저용
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }, [location.pathname, location.search, location.key, behavior, targetSelector]);

  return null;
}
